import { styled as a, Button as i } from "@mui/material";
import c from "./ApeironButtonDisableTip.js";
import { jsx as r } from "react/jsx-runtime";
const s = a(i)`
  --background-color: #005bd7;
  background-color: var(--background-color);
  border-radius: 2px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 300;
  height: 45px;
  text-transform: none;
  white-space: nowrap;
  transition: filter 0.3s ease-in-out;
  :hover {
    background-color: var(--background-color);
    filter: brightness(1.1);
  }
  :focus {
    background-color: var(--background-color);
  }
  &.Mui-disabled {
    background-color: #535556;
    color: #777979;
    pointer-events: all;
    :active {
      pointer-events: none;
    }
  }
`, f = (t) => {
  const {
    disabled: o,
    disableReason: e,
    ...n
  } = t;
  return /* @__PURE__ */ r(c, {
    disabled: o,
    reason: e,
    children: /* @__PURE__ */ r(s, {
      disabled: o,
      ...n
    })
  });
};
export {
  f as default
};
//# sourceMappingURL=ApeironBlueButton.js.map
